


































































































































import Vue from "vue";

export default Vue.extend({
  name: "Resume",
  components: {
    // SkillRate,
  },
});
